import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const useQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = useMemo(() => {
    const arr = Array.from(searchParams.entries());
    return Object.fromEntries(
      arr.map(([key, val]) => {
        if (key=== "uuidPromocion"){
          return [key, JSON.parse(JSON.stringify(val))]
        }else{
          return [key, JSON.parse(val)]
        }
      })
    );
  }, [searchParams]);

  const setValue = useCallback(
    (newValue, options, toDelete) => {
      const newSearchParams = new URLSearchParams(searchParams);
      toDelete?.forEach((key) => newSearchParams.delete(key));
      Object.entries(newValue).forEach(([key, val]) => {
        newSearchParams.set(key, JSON.stringify(val));
      });
      setSearchParams(newSearchParams, options);
    },
    [searchParams, setSearchParams]
  );

  return [value, setValue];
};

export default useQuery;
